import { CommonResponse, get, post } from './common.ts'

/**
 * (01)
 * 선생님 로그인
 */

//POST /teachers/signin
interface PostTeachersSignInRequest {
  userId: string
  password: string
}

export const postTeachersSignIn = async (
  body: PostTeachersSignInRequest,
): Promise<CommonResponse<null>> => {
  return await post('/teachers/signin', body)
}

/**
 * (02)
 * 강의 시간 조회
 */

// GET /teachers/{semesterId}/course-time
interface GetTeachersCourseTimeRequest {
  semesterId: string
}
interface GetTeachersCourseTimeResponse {
  dayOfWeek: string
  periods: number
}

export const getTeachersCourseTime = async (
  request: GetTeachersCourseTimeRequest,
): Promise<CommonResponse<GetTeachersCourseTimeResponse>> => {
  return await get(`/teachers/${request.semesterId}/course-time`)
}

/**
 * (03)
 * 전자칠판 로그인 코드 발급
 */

// GET /teachers/signin/code
interface GetTeachersSignInCodeResponse {}

export const getTeachersSignInCode = async (): Promise<
  CommonResponse<GetTeachersSignInCodeResponse>
> => {
  return await get('/teachers/signin/code')
}
